export interface StudentRegistrationRequest {
  email: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface LoginRequest {
  email: string;
  password: string;
  deviceId?: string;
  fingerprintHash?: string;
  deviceLabel?: string;
}

export interface GoogleLoginRequest {
  idToken: string;
  deviceId?: string;
  fingerprintHash?: string;
  deviceLabel?: string;
}

export interface LoginResponse {
  success: boolean;
  message: string;
  data: {
    user: PublicUser;
    accessToken: string;
    refreshToken: string;
    deviceId?: string;
    requiresPhone?: boolean;
  };
  errors: string[];
  timestamp: string;
  requestId: string;
}

export interface CompletePhoneResponse {
  success: boolean;
  message: string;
  data: {
    user: PublicUser;
    requiresPhone?: boolean;
  };
  errors: string[];
  timestamp: string;
  requestId: string;
}

export interface RegistrationResponse {
  success: boolean;
  message: string;
  data: {
    message: string;
    email: string;
    verificationRequired: boolean;
    nextSteps: string[];
  };
  errors: string[];
  timestamp: string;
  requestId: string;
}

export interface RefreshTokenResponse {
  success: boolean;
  message: string;
  data: {
    user: PublicUser;
    accessToken: string;
    refreshToken: string;
    deviceId?: string;
  };
  errors: string[];
  timestamp: string;
  requestId: string;
}

export interface PublicUser {
  id: number;
  email: string;
  fullName: string;
  firstName: string;
  phone?: string;
  cccd?: string | null;
  address?: string | null;
  status: UserStatus;
  roles: UserRole[];
  isActive: boolean;
  catJobId?: number;
  createdAt: Date;
  updatedAt: Date;
}

export enum UserRole {
  STUDENT = 'STUDENT',
  ADMIN = 'ADMIN'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BANNED = 'BANNED'
}

export interface AuthError {
  success: false;
  message: string;
  data: null;
  errors: string[];
  timestamp: string;
  requestId: string;
}

export interface ValidationError {
  field: string;
  message: string;
}

export interface PasswordValidation {
  isValid: boolean;
  errors: string[];
}

export interface FormField {
  value: string;
  error: string;
  touched: boolean;
}

export interface RegistrationFormState {
  email: FormField;
  password: FormField;
  confirmPassword: FormField;
  firstName: FormField;
  lastName: FormField;
  phone: FormField;
}